import { log } from 'log';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useSportsbookDestroyOnLangChange = () => {
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const defaultLanguage = useAppSelector(prop('defaultLocale'));
    const stayOnLangSwitch = useAppSelector(prop('stayOnLangSwitch'));

    useEffect(() => {
        if (!lang || !defaultLanguage) {
            return;
        }

        const language = (lang || defaultLanguage).replace('_', '-');

        if (window.Sportsbook?.initializationState === 'INITIALIZED' && window.Sportsbook?.language !== language) {
            try {
                window.Sportsbook?.dispose();

                if (stayOnLangSwitch) {
                    dispatch(actions.setAppInitialized(false));
                } else {
                    dispatch(actions.stopIntegration());
                }
            } catch (error) {
                log('error', '[SPORTSBOOK | Portal] Destroying app error', error);
            }
        }
    }, [lang, defaultLanguage, dispatch, stayOnLangSwitch]);
};
